import Events from '@utilities/events'
import isNumeric from '@utilities/is-numeric'

const JS_HOOK_QUANTITY = '[js-hook-minicart-quantity]'
const JS_HOOK_QUANTITY_VALUE = '[js-hook-minicart-quantity-value]'
const JS_HOOK_LINK = '[js-hook-minicart-link]'
const JS_HOOK_TITLE = '[js-hook-minicart-title]'
const CLASS_HIDE_QUANTITY = 'button__quantity--hidden'

class Minicart {
  constructor(element) {
    this.element = element
    this.ui = {
      quantity: this.element.querySelector(JS_HOOK_QUANTITY),
      quantityValue: this.element.querySelector(JS_HOOK_QUANTITY_VALUE),
      link: this.element.querySelector(JS_HOOK_LINK),
      title: this.element.querySelector(JS_HOOK_TITLE),
    }

    if (this.ui.link === 'undefined') return

    // COMMENT: Unformatted texts from ".properties", need {0} to replace with cart items count
    this.titleShort = this.ui.link?.dataset?.titleShort
    this.titleLongSingle = this.ui.link?.dataset?.titleLongSingle
    this.titleLongPlural = this.ui.link?.dataset?.titleLongPlural

    this.bindEvents()
  }

  /**
   * Update quantity value in minicart
   * @param data {object} - data returned from API endpoint controlling quantity in cart.
   */
  updateMiniCartQuantity(data) {
    if (!data || this.ui.link === 'undefined') return

    const pendingTotalItemsInCart = data.quantityTotal || data.numItems || 0

    if (data && isNumeric(pendingTotalItemsInCart)) {
      const newLongTitle = this.getLongTitle(pendingTotalItemsInCart)
      const newShortTitle = this.titleShort.replace('{0}', pendingTotalItemsInCart)

      this.ui.link.setAttribute('title', newLongTitle)
      this.ui.link.setAttribute('aria-label', newLongTitle)
      this.ui.title.innerText = newShortTitle
      this.ui.quantityValue.innerText = pendingTotalItemsInCart

      if (pendingTotalItemsInCart > 0) {
        this.ui.quantity.classList.remove(CLASS_HIDE_QUANTITY)
      } else {
        this.ui.quantity.classList.add(CLASS_HIDE_QUANTITY)
      }
    }
  }

  /**
   * Get correct title for single or plural items
   * @param amount
   * @returns {string}
   */
  getLongTitle(amount) {
    const title = amount === 1 ? this.titleLongSingle : this.titleLongPlural
    const numberedTitle = title.replace('{0}', amount)
    return `${numberedTitle}`
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    Events.$on('minicart::update', (e, data) => this.updateMiniCartQuantity(data))
  }
}

export default Minicart

